function webpackEmptyAsyncContext(req) {
  // Here Promise.resolve().then() is used instead of new Promise() to prevent
  // uncaught exception popping up in devtools
  return Promise.resolve().then(function() {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  });
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "../../../resources/frontend_client/app/locales lazy recursive ^\\.\\/.*\\.json$ referencedExports: default";
module.exports = webpackEmptyAsyncContext;
